import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { RouterModule, Routes } from "@angular/router";

import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { HomeComponent } from "./home/home.component";
import { NgSelectModule } from "@ng-select/ng-select";
import { CardSnippetModule } from "@core/components/card-snippet/card-snippet.module";
import { HeaderModule } from "../authentication/header/header.module";
import { FooterModule } from "../authentication/footer/footer.module";
import { CoreDirectivesModule } from "@core/directives/directives";
import { ResultadosBusquedaComponent } from "./resultados-busqueda/resultados-busqueda.component";
import { HeaderBuscadorComponent } from "./header-buscador/header-buscador.component";
import { PropertyDetailsComponent } from "./property-details/property-details.component";
import { CurrencyPipe } from "@angular/common";
import { MapComponent } from "./map/map.component";
import { DigitalCardComponent } from "./digital-card/digital-card.component";
import { HttpClientModule } from "@angular/common/http";
import { NgxGalleryModule } from "@kolkov/ngx-gallery";
import { CurrencyCommasHundredsPipeLanding1 } from "./currency-commas-hundreds-landing-1.pipe";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { NgxVcardModule } from "ngx-vcard";
import { SweetAlert2Module } from "@sweetalert2/ngx-sweetalert2";
import { UsImageComponent } from "./us-image/us-image.component";
// import { LightboxModule } from 'ng-gallery/lightbox';

import { SwiperConfigInterface, SwiperModule, SWIPER_CONFIG } from "ngx-swiper-wrapper";
import { PrivacyPolicyComponent } from "./privacy-policy/privacy-policy.component";
import { CustomCurrencyPipe } from "@core/pipes/custom-currency.pipe";
import { CoreCommonModule } from "@core/common.module";
import { HeaderBuscadorModule } from "./header-buscador/header-buscador.module";
import { ProyectoComponent } from "./proyecto/proyecto.component";
import { BuildingComponent } from "./building/building.component";
import { LayoutComponent } from "./layout/layout.component";
import { RatingComponent } from "./resultados-busqueda/components/rating/rating.component";

// swiper configuration
// import { LightboxModule } from 'ng-gallery/lightbox';
const DEFAULT_SWIPER_CONFIG: SwiperConfigInterface = {
  observer: true,
  direction: "horizontal",
  threshold: 50,
  spaceBetween: 5,
  slidesPerView: 1,
  centeredSlides: true,
};

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "cln/:id/:client_name/:tipo",
    component: ResultadosBusquedaComponent,
  },
  {
    path: "proyecto/:id_project/inmobiliaria/:id_real_estate",
    component: ProyectoComponent,
  },
  {
    path: "detalles/:id",
    component: PropertyDetailsComponent,
  },
  {
    path: "map",
    component: MapComponent,
  },
  {
    path: "nosotros",
    component: UsImageComponent,
  },
  {
    path: "privacy_policy",
    component: PrivacyPolicyComponent,
  },
  {
    path: ":code",
    component: DigitalCardComponent,
  },
];

@NgModule({
  declarations: [
    HomeComponent,
    ResultadosBusquedaComponent,
    PropertyDetailsComponent,
    MapComponent,
    DigitalCardComponent,
    CurrencyCommasHundredsPipeLanding1,
    UsImageComponent,
    PrivacyPolicyComponent,
    ProyectoComponent,
    BuildingComponent,
    LayoutComponent,
    RatingComponent,
  ],
  imports: [
    CommonModule,
    CoreCommonModule,
    RouterModule.forChild(routes),
    NgbModule,
    FormsModule,
    ReactiveFormsModule,
    NgSelectModule,
    CardSnippetModule,
    HeaderModule,
    FooterModule,
    CoreDirectivesModule,
    HttpClientModule,
    NgxGalleryModule,
    ClipboardModule,
    NgxVcardModule,
    SweetAlert2Module.forRoot(),
    CardSnippetModule,
    SwiperModule,
    HeaderBuscadorModule,
  ],
  providers: [
    CurrencyPipe,
    {
      provide: SWIPER_CONFIG,
      useValue: DEFAULT_SWIPER_CONFIG,
    },
  ],
})
export class LandingModule {}
